export default new Error('onPrescriptionPrinted must be a function.')
